import { useTelegram } from '../../../assets/hooks/useTelegram';
import './TelegramUserAvatar.css';

function getAvatarStyle(photoUrl) {
  if (typeof photoUrl !== 'string' || !photoUrl) {
    return undefined;
  }

  return {
    backgroundImage: `url(${JSON.stringify(photoUrl)}), var(--telegram-user-avatar-fallback)`,
  };
}

function TelegramUserAvatar({ className = '', ...props }) {
  const { user } = useTelegram();
  const classes = ['telegram-user-avatar', className].filter(Boolean).join(' ');

  return (
    <span
      className={classes}
      style={getAvatarStyle(user?.photo_url)}
      aria-hidden="true"
      {...props}
    />
  );
}

export default TelegramUserAvatar;
